import { InlineNotification } from '@carbon/react';
import { RiskBanner } from 'types/api-responses';
import { format0 } from 'utils/number';

interface AssetRiskBannerProps {
  banner: RiskBanner | null | undefined;
  /** Total asset count shown in the surrounding table, used to render "N of M". */
  totalAssetCount?: number;
  className?: string;
}

const AssetRiskBanner = ({
  banner,
  totalAssetCount,
  className,
}: AssetRiskBannerProps) => {
  if (!banner?.hasRiskedAssets) return null;

  const { riskedAssetCount, titleQualityBreakdown } = banner;
  const risked = format0(riskedAssetCount);
  const leader =
    typeof totalAssetCount === 'number'
      ? `${risked} of ${format0(totalAssetCount)} assets have title risk`
      : `${risked} ${
          riskedAssetCount === 1 ? 'asset has' : 'assets have'
        } title risk`;

  return (
    <div className={className}>
      <InlineNotification
        kind="warning"
        lowContrast
        hideCloseButton
        title="Title Risk Assessment"
        subtitle={`${leader} — High: ${format0(
          titleQualityBreakdown.high
        )} · Medium: ${format0(titleQualityBreakdown.medium)} · Low: ${format0(
          titleQualityBreakdown.low
        )}`}
      />
    </div>
  );
};

export default AssetRiskBanner;
